import * as React from "react";
import { react2Angular } from "~/Core/React2Angular";
import { TS } from "~/Services/TS";
import { PropertyDefinition } from "~/Types/PropertyDefinition";
import { useFileBrowser } from "~/Components/EntityForm/FileBrowser";

export const FilePicker = (props: {
    propertyDefinition: PropertyDefinition;
    value: string;
    onChange: (name: string, value: string, isCustomProperty: boolean) => void;
    pattern: string;
}) => {
    const { isCustomProperty, isRequired, canEdit, name, fieldName } = props.propertyDefinition;

    const callOnChange = (newValue: string) => {
        if (newValue !== props.value) {
            props.onChange(name, newValue, isCustomProperty);
        }
    };

    const { openFileBrowser } = useFileBrowser(callOnChange);

    return (
        <div className="file-picker large">
            <span className="inline-label">
                <input
                    type="text"
                    id={fieldName}
                    name={fieldName}
                    required={isRequired}
                    pattern={props.pattern}
                    value={props.value}
                    onChange={event => callOnChange(event.currentTarget.value)}
                />
                <button type="button" className="button" onClick={() => openFileBrowser()} disabled={!canEdit}>
                    {TS("Browse")}
                </button>
            </span>
        </div>
    );
};

angular
    .module("insite-admin")
    .component(
        "filePicker",
        react2Angular(FilePicker, ["serializedPropertyDefinition", "value", "onChange", "pattern"]),
    );
